/* eslint-disable */
const COMMON_STATE = {
};
export default COMMON_STATE;
